import * as React from "react";
import { useEffect } from "React";
import {
  Toolbar,
  Typography,
  Theme,
  makeStyles,
  createStyles,
  Hidden,
  IconButton,
  Divider,
  Box,
  useTheme,
  AppBar,
  Tooltip,
} from "@material-ui/core";
import UserMenu from "../UserMenu";
import MenuIcon from "@material-ui/icons/Menu";
import { useHubx } from "../../HubX";
import useConstructor from "../../core/hooks/useConstructor";
import { EVENT_OPEN_DRAWER } from "../../Events";
import APPLogo from "../../assets/icons/AppLogo";
import clsx from "clsx";
import WMLettersLogo from "../../assets/icons/WMLettersLogo";
import Notification from "../../features/Notification";
import DarkModeSwitch from "../../features/DarkModeSwitch";
import IUserResponse from "../../core/contracts/IUserResponse";
import { SessionCache } from "../../helpers/cache";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import YouTube from "@material-ui/icons/YouTube";
import { useState } from "react";
import VideoModal from "../Modal";
import BaseService from "../../services/BaseService";
import { FETCH_ALL_VIDEOS_AFTER_SALES } from "../../Fedx";
import { useSnackbar } from "notistack";
import VideoAfterSales from "../../core/models/VideoAfterSales";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
    },

    menuWrapper: {
      "display": "flex",
      "flex": 1,
      "justifyContent": "space-between",
      "alignItems": "center",

      "& h1": {
        fontWeight: "bold",
      },
    },

    menuWrapper2: {
      display: "flex",
      flex: 1,
      justifyContent: "flex-end",
      alignItems: "center",
    },

    iconsWrapper: {
      "display": "flex",
      "alignItems": "center",

      "& .menu-icon": {
        flex: 1,
      },
    },

    avatar: {
      color: theme.palette.text.secondary,
    },

    appNameWrapper: {
      "columnGap": `${theme.spacing(2)}px`,
      "& svg": {
        width: "1.5em",
        height: "1.5em",
      },
    },

    mobileIcon: {
      "& svg": {
        width: "2em",
        height: "2em",
      },
    },

    mobileAppBar: {
      background: theme.customPaper.background.cardBackground,
    },
  })
);

function Header() {
  const [videosPosVenda, setVideosPosVenda] = React.useState<null | VideoAfterSales[]>(null);
  const classes = useStyles();
  const hub = useHubx();
  const toastr = useSnackbar();
  const theme = useTheme();

  const [userName, setUserName] = React.useState<string>("");

  const fetchVideos = async () => {
    // setLoading(true);
    try {
      const videos = await hub.request(FETCH_ALL_VIDEOS_AFTER_SALES);
      setVideosPosVenda(videos);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("🚀 ~ file: index.tsx ~ line 125 ~ fetchFilters ~ error", error);
      toastr.enqueueSnackbar("Ops! Ocorreu um erro ao obter os videos!");
    } finally {
      // setLoading(false);
    }
  };

  useConstructor(async () => {
    await fetchVideos();
  });

  React.useEffect(() => {
    const sessionCache = new SessionCache();
    const userData = sessionCache.get<IUserResponse>("user");
    if (userData) {
      setUserName(userData?.name || "");
    }
  }, []);

  const handleClick = () => {
    hub.notify(EVENT_OPEN_DRAWER);
  };

  const handleDownload = () => {
    if (window != null) {
      window?.open("/tutorial-gerenciar.pdf", "_blank")?.focus();
    }
  };

  const [modalIsOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Mobile */}
      <Hidden smUp>
        <AppBar className={classes.mobileAppBar}>
          <Toolbar>
            <div className={classes.iconsWrapper}>
              <IconButton className="menu-icon" onClick={handleClick}>
                <MenuIcon />
              </IconButton>
            </div>

            <div className={classes.menuWrapper}>
              <span className={classes.mobileIcon}>
                <WMLettersLogo viewBox="15 15 55 55" backgroundColor={theme.palette.primary.main} />
              </span>

              <div className={classes.menuWrapper2}>
                {/* <IconButton
                  onClick={() => setIsOpen(true)}
                  aria-haspopup="true"
                  className={clsx(classes.avatar)}
                >
                  <Tooltip title="Assista os vídeos de tutoriais do pós-venda">
                    <YouTube />
                  </Tooltip>
                </IconButton> */}
                {modalIsOpen ? (
                  <VideoModal
                    videosPosVenda={videosPosVenda}
                    onClickClose={() => setIsOpen(false)}
                  />
                ) : null}

                <IconButton
                  onClick={handleDownload}
                  aria-label="Download"
                  aria-haspopup="true"
                  className={clsx(classes.avatar)}
                >
                  <Tooltip title="Clique aqui para download do manual de instalação do aplicativo mobile">
                    <PhoneIphoneIcon />
                  </Tooltip>
                </IconButton>

                <Notification />
                <DarkModeSwitch />
                <UserMenu name={userName} />
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </Hidden>

      {/* Desktop */}
      <Hidden xsDown>
        <Toolbar className={classes.root}>
          <div className={classes.menuWrapper}>
            <div className={clsx(classes.iconsWrapper, classes.appNameWrapper)}>
              <Typography component="h1" variant="h3" color="textSecondary">
                WM GerenciAR
              </Typography>

              <APPLogo />
            </div>

            <div className={classes.menuWrapper2}>
              <IconButton
                onClick={() => setIsOpen(true)}
                aria-haspopup="true"
                className={clsx(classes.avatar)}
              >
                <Tooltip title="Assista os vídeos de tutoriais do pós-venda">
                  <YouTube />
                </Tooltip>
              </IconButton>
              {modalIsOpen ? (
                <VideoModal videosPosVenda={videosPosVenda} onClickClose={() => setIsOpen(false)} />
              ) : null}

              <IconButton
                aria-label="Download"
                aria-haspopup="true"
                className={clsx(classes.avatar)}
              >
                <Tooltip title="Clique aqui para download do manual de instalação do aplicativo mobile">
                  <PhoneIphoneIcon />
                </Tooltip>
              </IconButton>
              <Notification />
              <DarkModeSwitch />
              <UserMenu name={userName} />
            </div>
          </div>
        </Toolbar>

        <Box height={2} boxShadow={2} bgcolor="#626B6B">
          <Divider />
        </Box>
      </Hidden>
    </>
  );
}

export default Header;
